export type SaconGroupPresentationStatus = 'normal' | 'warning' | 'caution';

const SACON_ALERT_STATES = new Set(['ALERT', 'TUNNEL_ALERT', 'SEALED_ALERT']);

/**
 * SACON 그룹 상태를 운용 화면 상태로 변환합니다.
 */
export function resolveSaconGroupPresentationStatus(value: unknown): SaconGroupPresentationStatus | null {
  if (typeof value !== 'string') {
    return null;
  }

  const normalizedValue = value.trim().toUpperCase();
  if (!normalizedValue || normalizedValue === 'ERROR') {
    return null;
  }

  if (normalizedValue === 'WARNING') {
    return 'caution';
  }

  if (SACON_ALERT_STATES.has(normalizedValue)) {
    return 'warning';
  }

  return 'normal';
}
